// extracted by mini-css-extract-plugin
export var chevron = "_j5-2";
export var dropdownItems = "_j5-0";
export var item = "_j5-1";